<div class="system-endorsement__image-wrapper">
  <img
    class="system-endorsement__image"
    [src]="'data:image/png;base64,' + endorsementImage?.endorsementImage"
    [alt]="altText"
    data-private
  />
</div>
